import { lazy } from "react";
import { routes } from "./index";
import Layout from "../layout";
import ProvidersWrapper from "../common/context/app-provider";
import Loadable from "../common/components/loadable";
import { Navigate } from "react-router";
import ScrollToTop from "../common/components/scroll-top";

const SignIn = Loadable(lazy(() => import("../pages/auth/signin")));
const SignUp = Loadable(lazy(() => import("../pages/auth/signup")));
const HomePage = Loadable(lazy(() => import("../pages/home")));
const AboutPage = Loadable(lazy(() => import("../pages/about")));
const HowItWorksPage = Loadable(lazy(() => import("../pages/how-it-works")));
const FAQsPage = Loadable(lazy(() => import("../pages/faqs")));
const PrivacyPolicyPage = Loadable(lazy(() => import("../pages/privacy-policy")));
const TermsOfUsePage = Loadable(lazy(() => import("../pages/terms-use")));
const CancellationPolicyPage = Loadable(lazy(() => import("../pages/cancellation-policy")));
const SearchResultPage = Loadable(lazy(() => import("../pages/search-page")));
const AdvisorProfile = Loadable(lazy(() => import("../pages/advisor-profile")));
const AdvisorProfilePublic = Loadable(lazy(() => import("../pages/advisor-ProfilePublic")));
const BeAdvisorPage = Loadable(lazy(() => import("../pages/be-advisor")));
const ReachUsPage = Loadable(lazy(() => import("../pages/reach-us")));
const ProfileDetailsPage = Loadable(lazy(() => import("../pages/profile/details")));
const ReportIssuePage = Loadable(lazy(() => import("../pages/reports-issue")));
const HistoryPage = Loadable(lazy(() => import("../pages/history")));
const AdvisorTopicDetailsPage = Loadable(lazy(() => import("../pages/advisor-topic-details")));
const AdvisorWordDetailsPage = Loadable(lazy(() => import("../pages/advisor-word-details")));
const ReschedulePage = Loadable(lazy(() => import("../pages/reschedule")));
const ScheduleViewDetailsPage = Loadable(lazy(() => import("../pages/schedule-view-details")));
const SettingsPage = Loadable(lazy(() => import("../pages/settings")));
const PaymentPage = Loadable(lazy(() => import("../../src/common/components/pages/auth/payment")));
const ChangePassword = Loadable(lazy(() => import("../pages/changePassword")))
const VerifyEmail = Loadable(lazy(() => import("../pages/auth/verify-email")));
const ForgotPassword = Loadable(lazy(() => import("../pages/auth/forgot-password")));


// Define which roles are allowed to access each route
const protectedRoutes = [
  { path: routes.SIGNIN, element: <SignIn /> },
  { path: routes.SIGNUP, element: <SignUp /> },
  { path: routes.HOME, element: <HomePage /> },
  { path: routes.ABOUT, element: <AboutPage /> },
  { path: routes.HOW_IT_WORKS, element: <HowItWorksPage /> },
  { path: routes.FAQS, element: <FAQsPage /> },
  { path: routes.PRIVACY_POLICY, element: <PrivacyPolicyPage /> },
  { path: routes.TERMS_USE, element: <TermsOfUsePage /> },
  { path: routes.CANCELLATION_POLICY, element: <CancellationPolicyPage /> },
  { path: routes.SEARCH, element: <SearchResultPage /> },
  { path: routes.ADVISOR_PROFILE, element: <AdvisorProfile /> },
  { path: routes.BE_AN_ADVISOR, element: <BeAdvisorPage /> },
  { path: routes.REACH_US, element: <ReachUsPage /> },
  { path: routes.PROFILE_DETAILS, element: <ProfileDetailsPage /> },
  { path: routes.REPORT_ISSUE, element: <ReportIssuePage /> },
  { path: routes.HISTORY, element: <HistoryPage /> },
  { path: routes.ADVISOR_TOPIC_DETAILS, element: <AdvisorTopicDetailsPage /> },
  { path: routes.ADVISOR_WORD_DETAILS, element: <AdvisorWordDetailsPage /> },
  { path: routes.RESCHEDULE, element: <ReschedulePage /> },
  { path: routes.SCHEDULE_DETAILS, element: <ScheduleViewDetailsPage /> },
  { path: routes.SETTINGS, element: <SettingsPage /> },
  { path: routes.CHANGE_PASSWORD, element: <ChangePassword /> },
  { path: routes.PAYMENT, element: <PaymentPage /> },
  { path: routes.INDEX_PATH, element: <Navigate to={routes.HOME} /> },
];

const publicRoutes = [
  { path: routes.ADVISOR_PROFILE_PUBLIC, element: <AdvisorProfilePublic /> },
  { path: routes.VERIFY_EMAIL, element: <VerifyEmail /> },
  { path: routes.FORGOT_PASSWORD, element: <ForgotPassword /> },
];

const mainRoutes = {
  element: (
    <ProvidersWrapper>
      <ScrollToTop />
      <Layout />
    </ProvidersWrapper>
  ),
  children: [...protectedRoutes, ...publicRoutes].map(({ path, element }) => ({
    path,
    element: <>{element}</>
  })),
};

export default mainRoutes;